module.exports = __webpack_public_path__ + "img/Pattern03.0181a098.png";